import { render, staticRenderFns } from "./CheckoutPaymentAddress.vue?vue&type=template&id=404a60aa&"
import script from "./CheckoutPaymentAddress.vue?vue&type=script&lang=ts&"
export * from "./CheckoutPaymentAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('404a60aa')) {
      api.createRecord('404a60aa', component.options)
    } else {
      api.reload('404a60aa', component.options)
    }
    module.hot.accept("./CheckoutPaymentAddress.vue?vue&type=template&id=404a60aa&", function () {
      api.rerender('404a60aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/checkout/payment/CheckoutPaymentAddress.vue"
export default component.exports